exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-btn.v-btn--floating.table-action-btn.v-btn{height:30px;max-width:30px;min-width:30px;width:30px\n}\n.export-data-btn{margin-left:8px;padding:0!important\n}", ""]);

// exports
